(function(){
  if (window.__cloudcotonSourceTrackerV3Loaded) return;
  window.__cloudcotonSourceTrackerV3Loaded = true;
  var COMPANY_ID = "VwCb9E";
  var METRIC = 'CloudCoton Traffic Source';
  var ATTR_KEY = 'cc_attribution_v1';
  function uuid(){try{return crypto.randomUUID();}catch(e){return String(Date.now())+'-'+Math.random().toString(16).slice(2);}}
  function safeGet(k){try{return localStorage.getItem(k)||'';}catch(e){return '';}}
  function safeSet(k,v){try{localStorage.setItem(k,v);}catch(e){}}
  function anon(){try{var k='cc_anon_id',v=localStorage.getItem(k);if(!v){v=uuid();localStorage.setItem(k,v);}return v;}catch(e){return 'anon-'+uuid();}}
  function qp(){try{return new URLSearchParams(location.search);}catch(e){return {get:function(){return '';}};}}
  function host(u){try{return u?new URL(u).hostname.replace(/^www\./,''):'';}catch(e){return '';}}
  function source(q,rh){var u=q.get('utm_source'); if(u)return u; if(q.get('gclid')||q.get('gbraid')||q.get('wbraid'))return 'google'; if(q.get('fbclid'))return 'meta'; if(q.get('ttclid'))return 'tiktok'; if(q.get('msclkid'))return 'bing'; if(!rh)return 'direct'; if(/google\./.test(rh))return 'google'; if(/bing\./.test(rh))return 'bing'; if(/facebook|instagram/.test(rh))return 'meta'; if(/tiktok/.test(rh))return 'tiktok'; if(/youtube/.test(rh))return 'youtube'; if(/pinterest/.test(rh))return 'pinterest'; return rh;}
  function compact(o){var r={}; Object.keys(o).forEach(function(k){if(o[k]!==undefined && o[k]!==null && String(o[k])!=='') r[k]=String(o[k]).slice(0,500);}); return r;}
  function capture(){
    var q=qp(), ref=document.referrer||'', rh=host(ref), aid=anon();
    if(!sessionStorage.getItem('cc_landing_page')) sessionStorage.setItem('cc_landing_page', location.pathname);
    var now=new Date().toISOString();
    var current=compact({
      anon_id:aid,
      source:source(q,rh),
      medium:q.get('utm_medium')||(rh?'referral':'direct'),
      campaign:q.get('utm_campaign')||'',
      term:q.get('utm_term')||'',
      content:q.get('utm_content')||'',
      gclid:q.get('gclid')||'',
      gbraid:q.get('gbraid')||'',
      wbraid:q.get('wbraid')||'',
      fbclid:q.get('fbclid')||'',
      ttclid:q.get('ttclid')||'',
      msclkid:q.get('msclkid')||'',
      landing_page:sessionStorage.getItem('cc_landing_page')||location.pathname,
      landing_url:location.href,
      referrer:ref,
      referrer_domain:rh,
      first_seen_at:now,
      last_seen_at:now,
      tracker_version:'v3'
    });
    var stored={}; try{stored=JSON.parse(safeGet(ATTR_KEY)||'{}')||{};}catch(e){stored={};}
    if(!stored.first_touch) stored.first_touch=current;
    stored.last_touch=current;
    stored.anon_id=aid;
    stored.updated_at=now;
    safeSet(ATTR_KEY, JSON.stringify(stored));
    return {stored:stored,current:current};
  }
  function flatAttrs(stored){
    var f=(stored&&stored.first_touch)||{}, l=(stored&&stored.last_touch)||{};
    return compact({
      cc_anon_id: stored.anon_id || l.anon_id || f.anon_id || '',
      cc_first_source: f.source,
      cc_first_medium: f.medium,
      cc_first_campaign: f.campaign,
      cc_first_landing: f.landing_page,
      cc_first_referrer: f.referrer_domain,
      cc_last_source: l.source,
      cc_last_medium: l.medium,
      cc_last_campaign: l.campaign,
      cc_last_landing: l.landing_page,
      cc_last_referrer: l.referrer_domain,
      cc_gclid: l.gclid || f.gclid,
      cc_gbraid: l.gbraid || f.gbraid,
      cc_wbraid: l.wbraid || f.wbraid,
      cc_fbclid: l.fbclid || f.fbclid,
      cc_ttclid: l.ttclid || f.ttclid,
      cc_msclkid: l.msclkid || f.msclkid,
      cc_attr_updated_at: stored.updated_at,
      cc_tracker_version: 'v3'
    });
  }
  function updateCartAttributes(stored){try{
    var attrs=flatAttrs(stored);
    if(!Object.keys(attrs).length) return;
    fetch('/cart/update.js',{method:'POST',headers:{'content-type':'application/json','accept':'application/json'},body:JSON.stringify({attributes:attrs}),keepalive:true,credentials:'same-origin'}).catch(function(){});
  }catch(e){}}
  function sendKlaviyo(props){try{
    var payload={data:{type:'event',attributes:{metric:{data:{type:'metric',attributes:{name:METRIC}}},profile:{data:{type:'profile',attributes:{anonymous_id:props.anon_id}}},properties:props,time:new Date().toISOString(),unique_id:uuid()}}};
    fetch('https://a.klaviyo.com/client/events?company_id='+encodeURIComponent(COMPANY_ID),{method:'POST',headers:{'accept':'application/vnd.api+json','content-type':'application/vnd.api+json','revision':'2026-04-15'},body:JSON.stringify(payload),keepalive:true,mode:'cors'}).catch(function(){});
  }catch(e){}}
  function fire(){try{
    var cap=capture();
    var props=Object.assign({}, cap.current, {page:location.pathname,page_url:location.href,title:document.title||'',user_agent:navigator.userAgent||'',screen:(screen&&screen.width?screen.width:'')+'x'+(screen&&screen.height?screen.height:'')});
    updateCartAttributes(cap.stored);
    sendKlaviyo(props);
  }catch(e){}}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',fire);else fire();
})();
